import * as React from "react";
import { Select } from "antd";
import _ from "lodash";
import "./style.scss";

const Option = Select.Option;

interface GroupBySelectProps {
  metric: string;
  view: string;
  initial_selection_key?: string;
  onMenuSelect?: (metric: string) => void;
  features?: any;
}

interface GroupBySelectState {}

export default class GroupBySelect extends React.Component<
  GroupBySelectProps,
  GroupBySelectState
> {
  shouldComponentUpdate(nextProps: any, nextState: any) {
    return !_.isEqual(this.props, nextProps);
  }

  handleSelection = (key: string) => {
    let group_by = group_by_key_map[key];

    if (this.props.onMenuSelect) {
      this.props.onMenuSelect(key == "group_by_null" ? null : group_by);
    }
  };

  getOptions = () => {
    let groupBys = groupByOptionsMap;

    // Feature flag grouping by region when viewing as a bar or pie graph
    if (
      this.props.features &&
      !this.props.features["bar_view_group_by_region"] &&
      (this.props.view == "bar" || this.props.view == "pie")
    ) {
      groupBys = _.omit(groupByOptionsMap, "group_by_region");
    }

    return getGroupByItems(this.props.metric, this.props.view, groupBys);
  };

  renderOptions = () => {
    let optionHash = this.getOptions();

    return _.toPairs(optionHash).map((option: string[]) => (
      <Option key={option[0]}>{option[1]}</Option>
    ));
  };

  validateOption = () => {
    const menuItems = this.getOptions() as any;

    if (menuItems[this.props.initial_selection_key]) {
      return this.props.initial_selection_key;
    } else {
      return _.keys(menuItems)[0];
      //return 'group_by_null'
    }
  };

  render() {
    return (
      <div className="group-by-select">
        <Select
          size="default"
          placeholder="Select Group By"
          style={{ width: "100%" }}
          value={this.validateOption()}
          onChange={this.handleSelection}
        >
          {this.renderOptions()}
        </Select>
      </div>
    );
  }
}

export const getGroupByItems = (
  metric: string,
  view: string,
  optionsMap: any = groupByOptionsMap
) => {
  const options = groupByOptions(metric, view);
  return _.pick(optionsMap, options);
};

const groupByOptions = (metric: string, view: string) => {
  switch (metric) {
    case "clicks":
      if (view === "bar" || view === "pie")
        return [
          "group_by_publication",
          "group_by_device",
          "group_by_channel",
          "group_by_region",
          "group_by_item",
          "group_by_section"
        ];

      if (view === "line") return ["group_by_date"];

      if (view === "map") return ["group_by_region"];

      if (view === "content") return ["group_by_item", "group_by_section"];

    case "opens":
    case "unique_engaged_visits":
    case "impressions":
    case "average_time_on_flyer":
      if (view === "bar")
        return ["group_by_publication", "group_by_device", "group_by_channel"];

      if (view === "line") return ["group_by_date"];

      if (view === "pie")
        return ["group_by_publication", "group_by_device", "group_by_channel"];

    case "item_views":
      if (view === "line") return ["group_by_date"];

      if (view === "bar" || view === "pie" || view === "content")
        return ["group_by_item", "group_by_section"];

    case "shopping_list":
      if (view === "bar" || view === "pie" || view === "content")
        return ["group_by_item", "group_by_section"];

      return ["group_by_item"];

    case "ttm":
      if (view === "bar" || view === "pie")
        return ["group_by_region", "group_by_item", "group_by_section"];

      if (view === "map") return ["group_by_region"];

      if (view === "content") return ["group_by_item", "group_by_section"];

    case "spend":
      if (view === "pie" || view === "bar") return ["group_by_publication"];

      if (view === "line") return ["group_by_date"];

      if (view === "table") {
        return ["group_by_budget"];
      }
    default:
      return [];
  }
};

const optionElement = (name: string) => {
  const icon = <img src={`/icon_${name.toLowerCase()}.svg`} />;

  return (
    <div
      className="group-by-option"
      data-automation-id={`group-by-${name.toLowerCase()}`}
    >
      {icon}
      <div className="group-by-text">{_.startCase(name)}</div>
    </div>
  );
};

const groupByOptionsMap: any = {
  group_by_date: optionElement("date"),
  group_by_publication: optionElement("publication"),
  group_by_device: optionElement("device"),
  group_by_channel: optionElement("channel"),
  group_by_region: optionElement("region"),
  group_by_item: optionElement("item"),
  group_by_budget: optionElement("budget"),
  group_by_section: optionElement("section")
};

export const group_by_key_map: any = {
  group_by_date: "date",
  group_by_publication: "publication",
  group_by_device: "device",
  group_by_channel: "channel",
  group_by_region: "region",
  group_by_item: "item",
  group_by_budget: "budget",
  group_by_section: "section"
};



// WEBPACK FOOTER //
// ./client/modules/AnalyticsMetric/components/Dropdown/GroupBySelect/index.tsx